import { Component, Input, ViewChild } from '@angular/core';
import { ScApiService, ScuiModalComponent } from '@sc-ui';
import { AppChatsService } from 'src/services/app-chats.service';
import { LocalizationService } from 'src/services/localization.service';
import { texts } from './candidate-base.texts';

@Component({
  standalone: false,
  selector: 'app-candidate-base',
  templateUrl: './candidate-base.component.html',
  styleUrls: ['./candidate-base.component.scss']
})
export class CandidateBaseComponent {

  texts = texts;

  @Input()
  candidate: any;

  @Input()
  project: any;

  message: any = null;

  isGenerating = false;

  isCopied = {};

  @ViewChild('messageModal')
  messageModal: ScuiModalComponent;

  constructor(private chatbot: AppChatsService, private api: ScApiService, public loc: LocalizationService) { }

  startDirectChat() {
    this.chatbot.candidateDirectChat(this.candidate.Id);
  }

  generateMessage() {
    if (this.isGenerating) return;
    this.isGenerating = true;

    this.api.get('projects/' + this.project.Id + '/candidates/' + this.candidate.Id + '/message').subscribe((d: any) => {
      this.message = d;
      this.messageModal.show();
      this.isGenerating = false;
    });
  }

  copyToClipboard(text: string, value: string) {

    if (!text) return;
    
    this.isCopied[value] = true;
    
    setTimeout(() => {
      this.isCopied[value] = false;
    }, 2000);

    navigator.clipboard.writeText(text).then(() => {
      console.log('Text copied to clipboard');
    }).catch(err => {
      console.error('Could not copy text: ', err);
    });
  }

}
